import React from "react";

// styles
import styles from "./TableSection.module.scss";
import cx from "classnames";

interface ITableSectionProps {
    title?: string;
}

const TableSection: React.FC<ITableSectionProps> = (props) => {
    const { title } = props;

    return (
        <div className={styles["tablelist-section"]}>
            {title && (
                <h3 className={cx(styles["tablelist-section-title"], "text-bold")}>
                    {title}
                </h3>
            )}
            <table className={styles["table"]}>
                <tbody className={styles["table-body"]}>{props.children}</tbody>
            </table>
        </div>
    );
};

export default TableSection;
